module.exports = __webpack_public_path__ + "static/home-callout-01-500cb8c3cf2bb3aaed741b8efa5105b3.jpg";